import React from "react";
import ContenidoNosotros from "../components/contenidoNosotros";
import Layout from "../components/layout";

const IndexPage = () => (
  <Layout>
    <ContenidoNosotros />
  </Layout>
);

export default IndexPage;
